@import '../flyout-item-styles.scss';

:host {
  display: block;
}

.flyout-nav-item {
  list-style: none;

  &.selected {
    .flyout-nav-item-trigger {
      background-color: $color-grey-01;
    }

    @include media-min(xl) {
      .item-title {
        @include font-style('strong-mid-size-text');
        line-height: 24px;
      }
    }
  }

  &.is-open {
    > .flyout-nav-item-trigger {
      background-color: $color-grey-01;

      .item-arrow {
        transform: rotate(90deg);
      }
    }
  }
}

.flyout-nav-item-trigger {
  width: 100%;
}

.item-title {
  @include font-style('text');

  @include media-min('xl') {
    @include font-style('mid-size-text');
    line-height: 24px;
  }
  color: $color-dark-blue-02;
}

.item-icon,
.item-arrow {
  color: $color-dark-blue-02;
  transition: transform 0.3s ease;
}

.flyout-nav-item-content {
  display: none;
  padding-left: 16px;
}
